/**
 * StaffCreateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffCreateRes
 */
export interface StaffCreateRes {
  /** 员工ID */
  id?: string
}

/**
 * StaffCreateRes Schema
 */
export const StaffCreateResSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '员工ID',
      format: 'string',
      type: 'string',
      label: '员工ID',
    },
  },
  type: 'object',
}
